import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=7f16ca7e&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=7f16ca7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f16ca7e",
  null
  
)

export default component.exports